import { render, staticRenderFns } from "./DashDemands.vue?vue&type=template&id=47bbb412&scoped=true&"
import script from "./DashDemands.vue?vue&type=script&lang=js&"
export * from "./DashDemands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbb412",
  null
  
)

export default component.exports